<template>
  <div class="text-center">
    <div id="fb-root"></div>
    <div
      class="fb-page"
      :data-href="this.url"
      data-tabs="timeline"
      data-small-header="true"
      data-adapt-container-width="true"
      data-hide-cover="false"
      data-show-facepile="false"
    >
      <blockquote :cite="this.url" class="fb-xfbml-parse-ignore">
        <a :href="this.url">Facebook</a>
      </blockquote>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true
    }
  },

  mounted() {
    if (window.FB) window.FB.XFBML.parse();
  }
};
</script>

<style scoped>
.text-center {
  width: 100%;
}
</style>
